import { IconName } from '@core/user-interface-legacy';

export enum AutomationTriggerType {
  CandidateMoved = 'candidate_moved',
  CandidateDisqualified = 'candidate_disqualified',
  CandidateOverdue = 'candidate_overdue',
  CandidateEvaluationStatusChanged = 'candidate_evaluation_status_changed',
  JobStatusChanged = 'offer_status_changed',
  JobOpeningsFilled = 'offer_openings_filled',
}

export type AutomationTrigger = {
  type: AutomationTriggerType;
  name: string;
  iconName: IconName;
  data: AutomationTriggerData[] | null;
};

export type AutomationTriggerData = {
  name: string;
  value: AutomationTriggerDataValue;
  label: string;
};

export type AutomationTriggerDataValue = number | string | null;

export enum TriggerCategory {
  Candidate = 'candidate',
  Job = 'offer',
}
